import BenchmarkDashboard from './BenchmarkDashboard';

export default BenchmarkDashboard;
